import { Brand } from '../../model/cris/brand';
import { BrandAttributes } from '../../model/cris/brand-attributes';
import { ModelPrepped, ModelWithoutId } from '../../type';
import { RestfulApiService } from '../restful-api.service';

class AttributeService extends RestfulApiService<BrandAttributes, Brand> {
    protected getFormName(): string {
        return 'brand_attribute';
    }

    protected getPath(parent: Brand | undefined): string {
        if (!parent) {
            throw new Error('Parent brand is required in AttributeService');
        }

        return `brands/${parent.id}/attrs`;
    }

    protected prepareSaveData(entity: ModelWithoutId<BrandAttributes>): ModelPrepped<BrandAttributes> {
        return {
            ...entity,
            clientId: undefined,
            dateCreated: undefined,
            dateEdited: undefined,
            userCreated: undefined,
            userEdited: undefined,
        };
    }
}

export const attributeService = new AttributeService();
